import React from "react";
import { t } from "i18next";
import { Button, Paper, Typography } from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useHistory } from "react-router";

export default function AnalyticsTeaser() {
  const history = useHistory();

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 3,
        flex: 1,
        minWidth: { xs: "100%", md: 220 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
        background: "linear-gradient(135deg, rgba(96,138,214,0.08) 0%, rgba(255,255,255,0.9) 100%)",
      }}
      onClick={() => history.push("/community?tab=analytics")}
    >
      <InsightsIcon sx={{ fontSize: 48, color: "#608ad6" }} />
      <Typography variant="h5" fontWeight="bold" sx={{ color: "#608ad6" }}>
        {t("analytics_teaser_title")}
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {t("analytics_teaser_desc")}
      </Typography>
      <Button
        size="small"
        endIcon={<ArrowForwardIcon />}
        sx={{ mt: "auto", color: "#608ad6" }}
      >
        {t("analytics_teaser_explore")}
      </Button>
    </Paper>
  );
}
